export const TypesTipoImagem = {
    TIPOSIMAGEM: "TIPOSIMAGEM"
  }
  
  const INITIAL = {
    Tipos: []
  }
  
  export default function tipoImagemReducer(state = INITIAL, action) {
    switch (action.type) {
      case TypesTipoImagem.TIPOSIMAGEM:
        return {
          Tipos: action.payload.Tipos
        }
      default:
        return {
          ...state
        }
    }
  }
  
  export const tipoImagemActions = {
    setTiposImagem
  }
  
  function setTiposImagem(res) {
    return {
      type: TypesTipoImagem.TIPOSIMAGEM,
      payload: { Tipos: res }
    }
  }